var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { StyleDefinition } from './style-definition';
import { isBase64 } from '../utils/is-base64';
/**
 * Class to create an image definition
 */
var Img = /** @class */ (function (_super) {
    __extends(Img, _super);
    /**
     * @param url Image URL or BASE64
     * @param fromDefinition It defines if the image is from definition "images" property
     */
    function Img(url, fromDefinition) {
        if (fromDefinition === void 0) { fromDefinition = false; }
        var _this = _super.call(this) || this;
        _this.url = url;
        _this.fromDefinition = fromDefinition;
        return _this;
    }
    /**
     * It gets the content with the image in base64
     */
    Img.prototype.build = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.toBase64()];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * It fits the image
     * @param fit {[ number, number ]}
     */
    Img.prototype.fit = function (fit) {
        this.content.fit = fit;
        return this;
    };
    /**
     * It adds opacity to the image
     * @param opacity 0 to 1
     */
    Img.prototype.opacity = function (opacity) {
        if (opacity > 1)
            opacity = 1;
        this.content.opacity = opacity;
        return this;
    };
    /**
     * It converts a image URL to Base64 and set the image
     */
    Img.prototype.toBase64 = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, e_1;
            var _this = this;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!(isBase64(this.url) || this.fromDefinition)) return [3 /*break*/, 1];
                        this.content.image = this.url;
                        return [2 /*return*/, Promise.resolve(this.content)];
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        _a = this.content;
                        return [4 /*yield*/, new Promise(function (resolve, reject) {
                                var img = new Image();
                                img.crossOrigin = 'Anonymous';
                                img.onload = function () {
                                    var canvas = document.createElement('canvas');
                                    var context = canvas.getContext('2d');
                                    canvas.width = img.width;
                                    canvas.height = img.height;
                                    context.drawImage(img, 0, 0);
                                    resolve(canvas.toDataURL("image/png"));
                                };
                                img.onerror = reject;
                                img.src = _this.url;
                            })];
                    case 2:
                        _a.image = _b.sent();
                        return [2 /*return*/, Promise.resolve(this.content)];
                    case 3:
                        e_1 = _b.sent();
                        throw new Error("The " + this.url + " can't be resolved");
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    return Img;
}(StyleDefinition));
export { Img };
//# sourceMappingURL=image.js.map


//////////////////
// WEBPACK FOOTER
// ./~/pdfmake-wrapper/lib/definitions/image.js
// module id = 1143
// module chunks = 4